import React, { useState, useEffect } from "react";
import axios from "axios";

import { Configs } from "../api";
const AddInput = () => {
  const [name, setname] = useState("");
  const [barItems, setItems] = useState([]);

  const [price, setprice] = useState("");
  const [ExtrasAvail, setExtrasAvail] = useState(false);

  const [catLoc, setcatLoc] = useState("");
  const adddata = async (e) => {
    e.preventDefault();
    console.log(ExtrasAvail);
    try {
      const result = await axios.post(Configs.extras, {
        name: name,
        price: price,
        itemId: catLoc,
        extrasavailable: ExtrasAvail,
      });

      //  console.log(result);
      window.location.reload();
    } catch (error) {
      console.log(error.message);
    }
  };
  const loadLocations = async () => {
    // console.log(catLoc)
    try {
      const result = await axios.get(Configs.items);
      // console.log(result.data.categories)

      if (result.data.items.length !== null) {
        setItems(result.data.items);
      } else {
        console.log("null");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    loadLocations();
  }, []);

  return (
    <div className="container-fluid">
      <h1 className="text-center mt-3">Extras</h1>
      <form className="d-flex mt-5 mb-3 algnItm" onSubmit={adddata}>
        <input
          type="text"
          className="form-control input-styl1"
          value={name}
          onChange={(e) => setname(e.target.value)}
          required
          placeholder="Name"
        ></input>

        <input
          type="text"
          className="form-control input-styl1"
          value={price}
          onChange={(e) => setprice(e.target.value)}
          required
          placeholder="Price"
        ></input>
        <select
          id="dropdown"
          value={barItems._id}
          className="form-control input-styl1"
          onChange={(e) => setcatLoc(e.target.value)}
          required
        >
          <option value="">select Items</option>
          {barItems.map((loc) => (
            <option key={loc._id} value={loc._id}>
              {loc.name}
            </option>
          ))}
        </select>
        <div>
          <label>Extras Available</label>
          <input
            type="checkbox"
            value={ExtrasAvail}
            onChange={(e) => setExtrasAvail(!ExtrasAvail)}
            className="check-ext"
          ></input>
        </div>

        <button className="btn btn-success">add</button>
      </form>
    </div>
  );
};

export default AddInput;
